window.StickerCovenConfigurator =
  window.StickerCovenConfigurator || {};

window.StickerCovenConfigurator.CartService =
  class CartService {
    constructor(variantId) {
      this.variantId = Number.parseInt(
        variantId,
        10
      );
    }

    hasValidVariant() {
      return (
        Number.isFinite(this.variantId) &&
        this.variantId > 0
      );
    }

    async add(properties) {
      if (!this.hasValidVariant()) {
        throw new Error(
          "The product variant could not be found."
        );
      }

      const root =
        window.Shopify?.routes?.root || "/";

      const response = await fetch(
        `${root}cart/add.js`,
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json",

            Accept: "application/json"
          },

          body: JSON.stringify({
            items: [
              {
                id: this.variantId,

                /*
                 * Shopify quantity remains 1 because
                 * the sticker count is stored as a
                 * custom product property.
                 */
                quantity: 1,

                properties
              }
            ]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          "The item could not be added."
        );
      }

      return {
        result,
        cartUrl: `${root}cart`
      };
    }
  };